import { render, staticRenderFns } from "./TraitsAndWeaponsWidget.vue?vue&type=template&id=1936b456&scoped=true"
import script from "./TraitsAndWeaponsWidget.vue?vue&type=script&lang=js"
export * from "./TraitsAndWeaponsWidget.vue?vue&type=script&lang=js"
import style0 from "./TraitsAndWeaponsWidget.vue?vue&type=style&index=0&id=1936b456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1936b456",
  null
  
)

export default component.exports